{
  "name": "jeecgboot-vue3",
  "version": "3.9.5",
  "author": {
    "name": "北京国炬信息技术有限公司",
    "email": "jeecgos@163.com",
    "url": "https://www.jeecg.com"
  },
  "scripts": {
    "pinstall": "pnpm install",
    "clean:cache": "rimraf node_modules/.cache/ && rimraf node_modules/.vite",
    "dev": "vite",
    "build": "cross-env NODE_ENV=production NODE_OPTIONS=--max-old-space-size=8192 vite build && esno ./build/script/postBuild.ts && esno ./build/script/copyChat.ts",
    "build:docker": "cross-env NODE_ENV=docker NODE_OPTIONS=--max-old-space-size=8192 vite build --mode docker && esno ./build/script/postBuild.ts && esno ./build/script/copyChat.ts",
    "build:dockercloud": "cross-env NODE_ENV=dockercloud NODE_OPTIONS=--max-old-space-size=8192 vite build --mode dockercloud && esno ./build/script/postBuild.ts && esno ./build/script/copyChat.ts",
    "build:report": "pnpm clean:cache && cross-env REPORT=true npm run build",
    "preview": "npm run build && vite preview",
    "reinstall": "rimraf pnpm-lock.yaml && rimraf yarn.lock && rimraf package.lock.json && rimraf node_modules && npm run install",
    "clean:lib": "rimraf node_modules",
    "gen:icon": "esno ./build/generate/icon/index.ts",
    "batch:prettier": "prettier --write  \"src/**/*.{js,json,tsx,css,less,scss,vue,html,md}\"",
    "upgrade:log": "conventional-changelog -p angular -i CHANGELOG.md -s",
    "husky:install": "husky install"
  },
  "dependencies": {
    "@ant-design/colors": "^7.2.1",
    "@ant-design/icons-vue": "^7.0.1",
    "@iconify/iconify": "^3.1.1",
    "@jeecg/aiflow": "3.9.5-beta",
    "@logicflow/core": "^2.2.4",
    "@logicflow/extension": "^2.3.0",
    "@logicflow/vue-node-registry": "^1.2.4",
    "@onlyoffice/document-editor-vue": "^1.6.1",
    "@tinymce/tinymce-vue": "4.0.7",
    "@traptitech/markdown-it-katex": "^3.6.0",
    "@vant/area-data": "^1.5.2",
    "@vue/shared": "^3.5.39",
    "@vueuse/core": "^10.11.1",
    "@zxcvbn-ts/core": "^3.0.4",
    "ant-design-vue": "^4.2.6",
    "axios": "^1.18.1",
    "clipboard": "^2.0.11",
    "codemirror": "^5.65.21",
    "cron-parser": "^4.9.0",
    "cropperjs": "^1.6.2",
    "crypto-js": "^4.2.0",
    "dayjs": "^1.11.21",
    "dom-align": "^1.12.4",
    "echarts": "^5.6.0",
    "emoji-mart-vue-fast": "^15.0.5",
    "enquire.js": "^2.1.6",
    "event-source-polyfill": "^1.0.31",
    "highlight.js": "^11.11.1",
    "intro.js": "^7.2.0",
    "lodash-es": "^4.18.1",
    "lodash.get": "^4.4.2",
    "lunar-javascript": "^1.7.7",
    "markdown-it": "^14.3.0",
    "markdown-it-link-attributes": "^4.0.1",
    "md5": "^2.3.0",
    "mockjs": "^1.1.0",
    "nprogress": "^0.2.0",
    "path-to-regexp": "^6.3.0",
    "perfect-scrollbar": "^1.5.6",
    "pinia": "^3.0.4",
    "pinyin-pro": "^3.28.1",
    "print-js": "^1.6.0",
    "qrcode": "^1.5.4",
    "qs": "^6.15.3",
    "resize-observer-polyfill": "^1.5.1",
    "showdown": "^2.1.0",
    "sortablejs": "^1.15.7",
    "swagger-ui-dist": "^5.32.8",
    "tinymce": "6.6.2",
    "vditor": "^3.11.2",
    "vue": "^3.5.39",
    "vue-color": "^3.3.3",
    "vue-cropper": "^0.6.5",
    "vue-cropperjs": "^5.0.0",
    "vue-grid-layout-v3": "^3.1.2",
    "vue-i18n": "^9.14.5",
    "vue-infinite-scroll": "^2.0.2",
    "vue-print-nb-jeecg": "^1.0.13",
    "vue-router": "^5.1.0",
    "vue-types": "^5.1.3",
    "vue3-scroll-seamless": "^1.0.6",
    "vuedraggable": "^4.1.0",
    "vxe-pc-ui": "4.6.12",
    "vxe-table": "4.13.31",
    "vxe-table-plugin-antd": "4.0.8",
    "xe-utils": "3.5.26",
    "xss": "^1.0.15"
  },
  "devDependencies": {
    "@commitlint/cli": "^18.6.1",
    "@commitlint/config-conventional": "^18.6.3",
    "@iconify/json": "^2.2.498",
    "@purge-icons/generated": "^0.10.0",
    "@types/codemirror": "^5.60.17",
    "@types/crypto-js": "^4.2.2",
    "@types/fs-extra": "^11.0.4",
    "@types/inquirer": "^9.0.10",
    "@types/intro.js": "^5.1.5",
    "@types/jest": "^29.5.14",
    "@types/lodash-es": "^4.17.12",
    "@types/mockjs": "^1.0.10",
    "@types/node": "^20.19.43",
    "@types/nprogress": "^0.2.3",
    "@types/pinyin": "^2.10.2",
    "@types/qrcode": "^1.5.6",
    "@types/qs": "^6.15.1",
    "@types/showdown": "^2.0.6",
    "@types/sortablejs": "^1.15.9",
    "@typescript-eslint/eslint-plugin": "^6.21.0",
    "@typescript-eslint/parser": "^6.21.0",
    "@vitejs/plugin-vue": "^6.0.7",
    "@vitejs/plugin-vue-jsx": "^5.1.6",
    "@vue/compiler-sfc": "^3.5.39",
    "@vue/test-utils": "^2.4.11",
    "autoprefixer": "^10.5.2",
    "big.js": "^6.2.2",
    "commitizen": "^4.3.2",
    "conventional-changelog-cli": "^4.1.0",
    "cross-env": "^7.0.3",
    "cz-git": "^1.13.1",
    "czg": "^1.13.1",
    "dingtalk-jsapi": "^3.2.9",
    "dotenv": "^16.6.1",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.2",
    "eslint-define-config": "^2.1.0",
    "eslint-plugin-jest": "^27.9.0",
    "eslint-plugin-prettier": "^5.5.6",
    "eslint-plugin-vue": "^9.33.0",
    "esno": "^4.8.0",
    "fs-extra": "^11.3.6",
    "http-server": "^14.1.1",
    "husky": "^8.0.3",
    "inquirer": "^9.3.8",
    "is-ci": "^3.0.1",
    "jest": "^29.7.0",
    "less": "^4.6.7",
    "lint-staged": "15.2.2",
    "npm-run-all": "^4.1.5",
    "picocolors": "^1.1.1",
    "postcss": "^8.5.16",
    "postcss-html": "^1.8.1",
    "postcss-less": "^6.0.0",
    "prettier": "^3.9.5",
    "pretty-quick": "^4.2.2",
    "rimraf": "^5.0.10",
    "rollup": "4.52.5",
    "rollup-plugin-visualizer": "5.14.0",
    "stylelint": "^16.26.1",
    "stylelint-config-prettier": "^9.0.5",
    "stylelint-config-recommended": "^14.0.1",
    "stylelint-config-recommended-vue": "^1.6.1",
    "stylelint-config-standard": "^36.0.1",
    "stylelint-order": "^6.0.4",
    "tinycolor2": "1.6.0",
    "ts-jest": "^29.4.11",
    "ts-node": "^10.9.2",
    "typescript": "^5.9.3",
    "unocss": "^66.7.5",

    "unplugin": "^3.4.0",
    "unplugin-icons": "^24.0.0",
    "unplugin-vue-components": "^32.1.0",
    "vite": "^8.1.4",
    "vite-plugin-compression": "^0.5.1",
    "vite-plugin-html": "^3.2.2",
    "vite-plugin-mkcert": "^1.17.12",
    "vite-plugin-mock": "^2.9.8",
    "vite-plugin-optimize-persist": "^0.1.2",
    "vite-plugin-package-config": "^0.1.1",
    "vite-plugin-purge-icons": "^0.10.0",
    "vite-plugin-pwa": "^1.3.0",
    "vite-plugin-qiankun": "^1.0.15",
    "vite-plugin-svg-icons": "^2.0.1",
    "vite-plugin-vue-setup-extend-plus": "^0.1.0",
    "vue-eslint-parser": "^9.4.3",
    "vue-tsc": "^1.8.27",
    "workbox-window": "^7.4.1"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jeecgboot/JeecgBoot.git"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jeecgboot/JeecgBoot/issues"
  },
  "homepage": "https://www.jeecg.com",
  "engines": {
    "node": "^18 || >=20"
  }
}
